import React, { useEffect, useState } from "react";
import UserManagement from "./UserManagement";
import OrganizationManagement from "./OrganizationConfiguration";


export default function AdminPage() {
  const { UserMgmt, ObjectConfig } =
    JSON.parse(sessionStorage.getItem("rolesAndPermission") || "{}");
  const [tabs, setTabs] = useState([]);
  const [tab, setTab] = useState();

  useEffect(() => {
    const allTabsToDisplay = [];
    if (UserMgmt?.canView) {
      allTabsToDisplay?.push({ label: "User Management", key: "user" });
    }

      if (ObjectConfig?.canView) {
      allTabsToDisplay?.push({
        label: "Organization Management",
        key: "object",
      });
    }
    
   
    if (allTabsToDisplay?.length > 0) {
      setTab(allTabsToDisplay[0].key);
      setTabs([...allTabsToDisplay]);
    }
  }, []);

  return (
    <div className="p-6">
      <div className="rounded-2xl bg-white p-6 shadow-md mb-8">
        <h2 className="text-2xl font-bold mb-4">Admin Settings</h2>
        <div className="flex gap-4">
          {tabs.map((t) => (
            <button
              key={t.key}
              className={`px-6 py-3 rounded-xl font-medium border transition-colors duration-150 ${
                tab === t.key
                  ? "bg-blue-700 text-white"
                  : "bg-white text-gray-800 border-gray-300"
              }`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        {tab === "user" && <UserManagement />}
        
        {}
        {tab === "object" && <OrganizationManagement />}
      </div>
    </div>
  );
}
